"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleBoxSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _ArticleBox = require("../ArticleBox");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Skeleton component for `ArticleBox`.
 *
 * @deprecated Will be removed in the next major version. As we are using SSG, we don't need to use Skeleton components.
 */
const ArticleBoxSkeleton = ({
  animation = 'pulse',
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const {
    spacing
  } = (0, _mui.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.ARTICLE_BOX_SKELETON),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      variant: "rectangular",
      width: "100%",
      height: "170px",
      animation: animation,
      sx: {
        borderRadius: spacing(1),
        marginBottom: spacing(3),
        maxWidth: isMobile ? _ArticleBox.ARTICLE_BOX_MOBILE_WIDTH : _ArticleBox.ARTICLE_BOX_DESKTOP_WIDTH
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      variant: "rectangular",
      width: "50px",
      height: "18px",
      animation: animation,
      sx: {
        marginBottom: spacing(3)
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      variant: "rectangular",
      width: "100%",
      height: "64px",
      animation: animation,
      sx: {
        marginBottom: spacing(1)
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      variant: "rectangular",
      width: "100%",
      height: "45px",
      animation: animation,
      sx: {
        marginBottom: spacing(2)
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      variant: "rectangular",
      width: "64px",
      height: "20px",
      animation: animation
    })]
  });
};
exports.ArticleBoxSkeleton = ArticleBoxSkeleton;
